import { __extends } from "tslib";
import { deepMix } from '@antv/util';
import { registerPlotType } from '../../base/global';
import BaseColumnLayer from '../column/layer';
var GroupColumnLayer = /** @class */ (function (_super) {
    __extends(GroupColumnLayer, _super);
    function GroupColumnLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'groupColumn';
        return _this;
    }
    GroupColumnLayer.getDefaultOptions = function () {
        return deepMix({}, _super.getDefaultOptions.call(this), {
            yAxis: {
                title: {
                    visible: true,
                },
            },
        });
    };
    GroupColumnLayer.prototype.getResponsiveTheme = function () {
        return this.themeController.getResponsiveTheme('column');
    };
    GroupColumnLayer.prototype.addGeometry = function () {
        _super.prototype.addGeometry.call(this);
    };
    GroupColumnLayer.prototype.adjustColumn = function (column) {
        column.adjust = [
            {
                type: 'dodge',
                marginRatio: 0.1,
            },
        ];
    };
    return GroupColumnLayer;
}(BaseColumnLayer));
export default GroupColumnLayer;
registerPlotType('groupColumn', GroupColumnLayer);
//# sourceMappingURL=layer.js.map